import React, { useCallback } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { RefreshActions } from '../state/refresh'
import { useDispatch } from 'react-redux'
import { useRequests } from '../requests/useRequests'

interface DeleteContractorDialogProps {
  ids: number[]
  handleClose: (b: boolean) => void
}

const DeleteContractorDialog = ({
  ids,
  handleClose
}: DeleteContractorDialogProps): JSX.Element => {
  const dispatch = useDispatch()
  const requestMaker = useRequests()

  const onSubmit = useCallback(async () => {
    handleClose(true)
    await requestMaker.deleteContractors(ids)
    dispatch(RefreshActions.refreshUserState())
  }, [ids, dispatch, handleClose, requestMaker])

  return (
    <div>
      <Dialog open onClose={handleClose}>
        <DialogTitle>Contractor</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Are you sure to delete contractor${ids.length > 1 ? 's' : ''}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose as any}>Cancel</Button>
          <Button
            onClick={() => {
              void onSubmit()
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default DeleteContractorDialog
